// Google Maps configuration — frontend.
//
// A Maps JavaScript API key is inherently a CLIENT-SIDE value: it travels in
// the `maps.googleapis.com/maps/api/js?key=...` request and is always visible
// in the browser. Google's security model for these keys is HTTP-REFERRER
// RESTRICTION (allowlist your domains in Google Cloud Console), NOT secrecy.
//
// Production env-var space is full, and Vite inlines `import.meta.env.VITE_*`
// at BUILD time — so we can't rely on a build-time env var in prod. Instead the
// key lives here as a committed literal (the frontend mirror of the backend
// `config/index.js` workaround used for the Uber Direct server envs). A real
// `VITE_GOOGLE_MAPS_API_KEY` env var, when present, still WINS (local/dev
// override); otherwise the literal below is used so the map works in prod with
// zero env vars.
//
// ⚠️ OPERATOR: this key MUST be restricted in Google Cloud Console —
//   • Application restriction → HTTP referrers → wenext domains (+ localhost for dev)
//   • API restriction → Maps JavaScript API, Places API, Places API (New), Geocoding API
//   Set a budget alert + per-API daily quota caps as a safety net (India free
//   tier is 70,000 req/month per Essentials SKU — well above normal usage).
const GOOGLE_MAPS_API_KEY_LITERAL = 'AIzaSyC_IdMKsGMg-Vzb2OoLesNFZJQ9UuMuhpc';

export const GOOGLE_MAPS_API_KEY: string =
  (import.meta.env.VITE_GOOGLE_MAPS_API_KEY as string | undefined) ||
  GOOGLE_MAPS_API_KEY_LITERAL ||
  '';

// True when a key is available (env or committed literal). Gates the
// "Pick on map" UI; when false, the manual address form is used unchanged.
export const GOOGLE_MAPS_ENABLED: boolean = Boolean(GOOGLE_MAPS_API_KEY);
